import AdminCertificationLayout from './admin_certification_layout';

const AdminCertificationPage = () => {
  return (
      <AdminCertificationLayout />
  );
};

export default AdminCertificationPage;